import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [
    // 首页
    {
      path: 'index',
      name: 'index',
      meta: {
        auth: true
      },
      component: _import('system/index')
    },
    {
      path: 'data-statistics',
      name: 'data-statistics',
      meta: {
        title: "数据统计",
        auth: true
      },
      component: _import('overview/data-statistics')
    },
    {
      path: 'blogger-list',
      name: 'blogger-list',
      meta: {
        title: "用户列表",
        auth: true
      },
      component: _import('blogger/blogger-list')
    },
    {
      path: 'blogger-detail/:id',
      name: 'blogger-detail',
      meta: {
        title: "用户详情",
        auth: true
      },
      component: _import('blogger/blogger-detail')
    },
    {
      path: 'blogger-search',
      name: 'blogger-search',
      meta: {
        title: "搜索推荐博主",
        auth: true
      },
      component: _import('blogger/blogger-search')
    },
    {
      path: 'blogger-tag',
      name: 'blogger-tag',
      meta: {
        title: "标签推荐博主",
        auth: true
      },
      component: _import('blogger/blogger-tag')
    },
    {
      path: 'soft-article',
      name: 'soft-article',
      meta: {
        title: "软文列表",
        auth: true
      },
      component: _import('content/soft-article')
    },
    {
      path: 'content-tags',
      name: 'content-tags',
      meta: {
        title: "标签管理",
        auth: true
      },
      component: _import('content/tags')
    },
    {
      path: 'prohibited-words',
      name: 'prohibited-words',
      meta: {
        title: "违禁词语",
        auth: true
      },
      component: _import('content/prohibited-words')
    },
    {
      path: 'group-list',
      name: 'group-list',
      meta: {
        title: "群管理",
        auth: true
      },
      component: _import('group/list')
    },
    {
      path: 'contribution-points',
      name: 'contribution-points',
      meta: {
        title: "贡献值明细",
        auth: true
      },
      component: _import('contribution-points/list')
    },
    {
      path: 'wallet-assets',
      name: 'wallet-assets',
      meta: {
        title: "钱包资产",
        auth: true
      },
      component: _import('wallet/assets')
    },
    {
      path: 'wallet-balance',
      name: 'wallet-balance',
      meta: {
        title: "余额钱包",
        auth: true
      },
      component: _import('wallet/balance')
    },
    {
      path: 'finance-address',
      name: 'finance-address',
      meta: {
        title: "地址列表",
        auth: true
      },
      component: _import('finance/address')
    },
    {
      path: 'token-list',
      name: 'token-list',
      meta: {
        title: "币种管理",
        auth: true
      },
      component: _import('finance/token')
    },
    {
      path: 'finance-recharge',
      name: 'finance-recharge',
      meta: {
        title: "充值明细",
        auth: true
      },
      component: _import('finance/recharge')
    },
    {
      path: 'finance-withdrawal',
      name: 'finance-withdrawal',
      meta: {
        title: "提现明细",
        auth: true
      },
      component: _import('finance/withdrawal')
    },
    {
      path: 'finance-transfer',
      name: 'finance-transfer',
      meta: {
        title: "划转明细",
        auth: true
      },
      component: _import('finance/transfer')
    },
    {
      path: 'messages-system-notifications',
      name: 'messages-system-notifications',
      meta: {
        title: "系统消息",
        auth: true
      },
      component: _import('messages/system-notifications')
    },
    {
      path: 'messages-notification-templates',
      name: 'messages-notification-templates',
      meta: {
        title: "通知模板",
        auth: true
      },
      component: _import('messages/notification-templates')
    },
    {
      path: 'messages-notification-queue',
      name: 'messages-notification-queue',
      meta: {
        title: "通知队列",
        auth: true
      },
      component: _import('messages/notification-queue')
    },
    {
      path: 'system-settings',
      name: 'system-settings',
      meta: {
        title: "角色管理",
        auth: true
      },
      component: _import('system-settings/role')
    },
    {
      path: 'admin-list',
      name: 'admin-list',
      meta: {
        title: "管理列表",
        auth: true
      },
      component: _import('system-settings/admin')
    },
    {
      path: 'admin-edit',
      name: 'admin-edit',
      meta: {
        title: "新增管理",
        auth: true
      },
      component: _import('system-settings/admin-edit')
    },
    {
      path: 'system-settings',
      name: 'system-settings',
      meta: {
        title: "角色管理",
        auth: true
      },
      component: _import('system-settings/role')
    },









    // 演示页面
    {
      path: 'page1',
      name: 'page1',
      meta: {
        title: '页面 1',
        auth: true
      },
      component: _import('demo/page1')
    },
    {
      path: 'page2',
      name: 'page2',
      meta: {
        title: '页面 2',
        auth: true
      },
      component: _import('demo/page2')
    },
    {
      path: 'page3',
      name: 'page3',
      meta: {
        title: '页面 3',
        auth: true
      },
      component: _import('demo/page3')
    },
    // 系统 前端日志
    {
      path: 'log',
      name: 'log',
      meta: {
        title: '前端日志',
        auth: true
      },
      component: _import('system/log')
    },
    // 刷新页面 必须保留
    {
      path: 'refresh',
      name: 'refresh',
      hidden: true,
      component: _import('system/function/refresh')
    },
    // 页面重定向 必须保留
    {
      path: 'redirect/:route*',
      name: 'redirect',
      hidden: true,
      component: _import('system/function/redirect')
    }
  ]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  }
]

/**
 * 错误页面
 */
const errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]